import React, { useEffect } from "react";
import Layout from "../../Components/Layout/Layout";
import "./Style.css";
import Faqscreen from "../../Components/FAQ/Accordian/Accordian";
import Glossary from "../../Components/FAQ/Glossary/Glossary";
const FaqLayout = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    localStorage.removeItem("cns");
    localStorage.removeItem("cip");
    localStorage.removeItem("cdp");
  }, []);
  return (
    <>
      <Layout className={"paddingSet"}>
        <div className="Faqscreen-parent">
          <Faqscreen isMobile={isMobile} />
          <Glossary />
        </div>
      </Layout>
    </>
  );
};
export default FaqLayout;
